$('.readmore').click(function (event) {
	event.preventDefault();
	var descriptionFull = document.querySelector('.collection-description-full');
	descriptionFull.style.display = 'block';
	var descriptionShort = document.querySelector('.collection-description-short');
	descriptionShort.style.display = 'none';
});

$(document).ready(function() {
$('ul.tabs').each(function(){
var active, content, links = $(this).find('a');
active = links.first().addClass('active');
content = $(active.attr('href'));
links.not(':first').each(function () {
$($(this).attr('href')).hide();
});
$(this).find('a').click(function(e){
active.removeClass('active');
content.hide();
active = $(this);
content = $($(this).attr('href'));
active.addClass('active');
content.show();
return false;
});
});
});

$(document).ready(function () {
	$(document).on('click', '.close-message', function (e) {
		e.preventDefault();
		if($(this).parents('.i-change-popup').length > 0) {
			$('body').removeClass('has-popup');
			$(this).parents('.i-change-popup').addClass('hidden');
		} else {
			$(this).parent().remove();
		}
	});
	$(document).on('click', '.button-i-change', function (e) {
		e.preventDefault();
		$('body').addClass('has-popup');
		if($('.i-change-popup').hasClass('hidden')) {
			$('.i-change-popup').removeClass('hidden')
		}
	});
	if ($(window).width() < 750) {
		$('.footer-block__heading').on('click', function () {
			$(this).parent().find('.footer-block__details-content').slideToggle();
			$(this).toggleClass('has-show');
		});
	}
	$('.i-change-popup').click(function (e) {
		var container = $(".i-change-popup:not(.hidden) .page-width");
		if (!container.is(e.target) && container.has(e.target).length === 0) {
			$('.i-change-popup').addClass('hidden');
			$('body').removeClass('has-popup');
		}
	});
	// clse filed search when close field
	$(document).on(
		'click',
		'.boost-pfs-search-btn-clear-suggestion',
		function (e) {
			$(this).closest('.boost-pfs-search-suggestion-mobile-top-panel').hide();
			$('body').removeClass('search-active');
			$('.boost-pfs-search-box').blur();
		}
	);

	/**
	 * Category Description readmore.
	 */
	let width = $(window).width();
	if (width < 768) {
		var showChar = 185;
	} else {
		var showChar = 631;
	}
	var ellipsestext = '';
	var moretext = 'Read more';
	var lesstext = 'Read less';

	$('.collections .description-content p').each(function () {
		var content = $(this).html();
		if (content.length > showChar) {
			var c = content.substr(0, showChar);
			var h = content.substr(showChar, content.length - showChar);
			var html =
				c +
				'<span class="moreellipses">' +
				ellipsestext +
				'</span><span class="morecontent"><span>' +
				h +
				'</span><a href="" class="read-more">' +
				moretext +
				'</a></span>';
			$(this).html(html);
		}
	});

	$('.read-more').click(function () {
		if ($(this).hasClass('less')) {
			$(this).removeClass('less');
			$(this).html(moretext);
			$(this).prev().removeClass('toggle');
		} else {
			$(this).addClass('less');
			$(this).html(lesstext);
			$(this).prev().addClass('toggle');
		}
		$(this).parent().prev().toggle();
		$(this).prev().toggle();
		return false;
	});

	/**------------- End -------------**/
	//Filter collection mobile, tablet sticky
	if ($('#main-collection-filters').length) {
		var distance = $('#main-collection-filters').offset().top,
			$window = $(window);
		if ($window.width() < 990) {
			$window.scroll(function () {
				if ($window.scrollTop() >= distance) {
					$('#main-collection-filters').addClass('go-sticky');
				} else {
					$('#main-collection-filters').removeClass('go-sticky');
				}
			});
		}
	}

	$('.slideshow').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: true,
		dots: true,
		autoplay: true,
		autoplaySpeed: 3000,
	});
	$('.featured-collection .grid').slick({
		infinite: false,
		slidesToShow: 4,
		swipeToSlide: true,
		arrows: true,
		dots: false,
		responsive: [
			{
				breakpoint: 750,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
					infinite: false,
				},
			},
		],
	});

	$('.collection-recommend .product-grid').slick({
		rows: 1,
		dots: true,
		arrows: true,
		infinite: true,
		speed: 300,
		slidesToShow: 4,
		slidesToScroll: 4,
		prevArrow: $('.collection-title .preview'),
		nextArrow: $('.collection-title .next'),
		responsive: [
			{
				breakpoint: 900,
				settings: {
					rows: 1,
					slidesToShow: 3,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 767,
				settings: {
					rows: 1,
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
		],
	});

	$(document).on(
		'click',
		'.product-size-popup-modal__content .product-popup-modal__content-info > ul > li',
		function (e) {
			$(this).toggleClass('active');
		}
	);

	/*ADDRESS FORM*/

	$(document).on('click', '#new-address', function (e) {
		$('#addAddress').toggleClass('d-none');
	});

	$(document).on('click', '#cancel-addressform', function (e) {
		$('#addAddress').addClass('d-none');
	});

	/*ALIGN HEIGHT PRODUCT*/

	function alignHeight(selector) {
		jQuery(selector).css('height', '');
		var minHeight = 0;

		jQuery(selector).each(function () {
			if (minHeight < jQuery(this).outerHeight()) {
				minHeight = jQuery(this).outerHeight();
			}
		});

		if (minHeight > 0) {
			jQuery(selector).css('height', minHeight);
		}
	}

	$('.stamped-product-reviews-badge').on('click', function (e) {
		console.log('on click');
		$('.rating-accordion details').attr('open','');
	});
	/* Product RecentlyViewed */
	Shopify.Products.recordRecentlyViewed();
	Shopify.Products.showRecentlyViewed({
		howManyToShow: 5,
	});
	//Slide Recomment Product
	var load_recomment_view = setInterval(function () {
		if ($('.product-recommendations .grid.product-grid').length) {
			$('.product-recommendations .grid.product-grid').not('.slick-initialized').slick({
				infinite: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				arrows: true,
				dots: false,
				responsive: [
					{
						breakpoint: 750,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							infinite: false,
						},
					},
				],
			});
			alignHeight(
				'.product-recommendations .card > .card__content .card__heading'
			);
			alignHeight(' .card-wrapper .card__inner');
			alignHeight(
				'.product-recommendations .card > .card__content .price__container'
			);
			alignHeight(
				'.product-recommendations .card > .card__content .shipping-time-and-cart'
			);

			function swymCallbackFn(swat) {
				swat.initializeActionButtons('.product-recommendations .product-grid');
			}
			if (!window.SwymCallbacks) {
				window.SwymCallbacks = [];
			}
			window.SwymCallbacks.push(swymCallbackFn);
			clearInterval(load_recomment_view);
		}
	}, 1000);

	var load_select_button = setInterval(function () {
		var checkSelectButton = $('.rc-radio.rc-radio--active');
		if (checkSelectButton.hasClass('onetime-radio')) {
			$(this).closest('.recharge-subscription-widget').addClass('onetime');
			$(this)
				.closest('.recharge-subscription-widget')
				.removeClass('subscription');
		}
		if (checkSelectButton.hasClass('subscription-radio')) {
			$(this).closest('.shopify-app-block').addClass('subscription');
			$(this).closest('.shopify-app-block').removeClass('onetime');
		}
		clearInterval(load_select_button);
	}, 1000);

	$(document).on('click', '.rc-radio.rc-option__onetime', function () {
		$(this).closest('.rc-container-wrapper').addClass('onetime');
		$(this).closest('.rc-container-wrapper').removeClass('subscription');
	});

	$(document).on('click', '.rc-radio.rc-option__subsave', function () {
		$(this).closest('.rc-container-wrapper').addClass('subscription');
		$(this).closest('.rc-container-wrapper').removeClass('onetime');
	});

	// Remove notification success in contact form
	$('.contact .form__message .close').on('click', function (e) {
		$('.contact .form__message').css('display', 'none');
	});

	$('#ContactForm').submit(function (e) {
		$('.contact .form__message').css('display', 'none');
	});

	// validate contact
	$('#ContactForm').validate();

	// Newsletter popup
	$('.newsletter-form-popup').validate();

	setTimeout(function () {
		alignHeight('.sub-collections a p');
		if (
			!$('body').hasClass('template-index') &&
			!$('body').hasClass('template-cart')
		) {
			alignHeight(
				'div:not(.product-recently-viewed) .card-wrapper .card__heading'
			);
		}
		alignHeight(
			'div:not(.product-recently-viewed)  .card-wrapper .card__inner'
		);
		alignHeight(
			'div:not(.product-recently-viewed) .card-wrapper .price__container'
		);
		alignHeight(
			'div:not(.product-recently-viewed) .card-wrapper .shipping-time-and-cart'
		);
		alignHeight('div:not(.product-recently-viewed) .footer-block__heading');
		if ($(window).width() > 767) {
			alignHeight('.multicolumn-landing-card__info .multicolumn-landing-card__info-content');
		}
		
	}, 500);
	var setHeightReview = setInterval(function () {
		if ($('.stamped-reviews-message-block').length > 0) {
			alignHeight('.stamped-reviews-message-block');
			clearInterval(setHeightReview);
			alignHeight(
				'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper'
			);
		}
	}, 500);
	jQuery(window).resize(function () {
		setTimeout(function () {
			alignHeight('.sub-collections a p');
			if (
				!$('body').hasClass('template-index') &&
				!$('body').hasClass('template-cart')
			) {
				alignHeight(
					'div:not(.product-recently-viewed)  .card-wrapper .card__heading'
				);
			}
			alignHeight(
				'div:not(.product-recently-viewed)  .card-wrapper .card__inner'
			);
			alignHeight(
				'div:not(.product-recently-viewed)  .card-wrapper .price__container'
			);
			alignHeight('.card-wrapper .shipping-time-and-cart');
			alignHeight(
				'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper'
			);
			alignHeight('.footer-block__heading');
		}, 500);
	});

	// FAQ accordian
	$('.page-faqs .card-heading').on('click', function () {
		if ($(this).parents('.accordian-card').hasClass('open')) {
			$(this).parents('.accordian-card').find('.card-body').slideUp();
			$(this).parents('.accordian-card').removeClass('open');
		} else {
			$('.page-faqs .card-body').slideUp();
			$('.page-faqs .accordian-card').removeClass('open');

			$(this).parents('.accordian-card').find('.card-body').slideDown();
			$(this).parents('.accordian-card').addClass('open');
		}
	});

	// Men size chart accordian
	$('.men-size-chart .card-heading').on('click', function () {
		if ($(this).parents('.accordian-card').hasClass('open')) {
			$(this).parents('.accordian-card').find('.card-body').slideUp(500);
			$(this).parents('.accordian-card').removeClass('open');
		} else {
			$('.men-size-chart .card-body').slideUp(500);
			$('.men-size-chart .accordian-card').removeClass('open');

			if (jQuery(window).width() >= 768) {
				$(this)
					.parents('.accordian-card')
					.find('.card-body')
					.slideDown(500, function () {
						$(this).css('display', 'flex');
					});
			} else {
				$(this).parents('.accordian-card').find('.card-body').slideDown(500);
			}

			$(this).parents('.accordian-card').addClass('open');
		}
	});

	// Women size chart accordian
	$('.women-size-chart .card-heading').on('click', function () {
		if ($(this).parents('.accordian-card').hasClass('open')) {
			$(this).parents('.accordian-card').find('.card-body').slideUp(500);
			$(this).parents('.accordian-card').removeClass('open');
		} else {
			$('.women-size-chart .card-body').slideUp(500);
			$('.women-size-chart .accordian-card').removeClass('open');

			if (jQuery(window).width() >= 768) {
				$(this)
					.parents('.accordian-card')
					.find('.card-body')
					.slideDown(500, function () {
						$(this).css('display', 'flex');
					});
			} else {
				$(this).parents('.accordian-card').find('.card-body').slideDown(500);
			}

			$(this).parents('.accordian-card').addClass('open');
		}
	});

	// Kid size chart accordian
	$('.kid-size-chart .card-heading').on('click', function () {
		if ($(this).parents('.accordian-card').hasClass('open')) {
			$(this).parents('.accordian-card').find('.card-body').slideUp(500);
			$(this).parents('.accordian-card').removeClass('open');
		} else {
			$('.kid-size-chart .card-body').slideUp(500);
			$('.kid-size-chart .accordian-card').removeClass('open');

			if (jQuery(window).width() >= 768) {
				$(this)
					.parents('.accordian-card')
					.find('.card-body')
					.slideDown(500, function () {
						$(this).css('display', 'flex');
					});
			} else {
				$(this).parents('.accordian-card').find('.card-body').slideDown(500);
			}

			$(this).parents('.accordian-card').addClass('open');
		}
	});

	// scroll header add sticky for dropdown result search
	var stickyTop = $('#shopify-section-header').offset().top;
	$(window).scroll(function () {
		var windowTop = $(window).scrollTop();
		if (stickyTop < windowTop) {
			$('.boost-pfs-search-suggestion-mobile-top-panel').addClass('sticky');
			$('#boost-pfs-search-suggestion-mobile').addClass('sticky');
			$('#shopify-section-header').addClass('shopify-section-header-sticky');
		} else {
			$('.boost-pfs-search-suggestion-mobile-top-panel').removeClass('sticky');
			$('#boost-pfs-search-suggestion-mobile').removeClass('sticky');
		}
	});
	if ($(window).width() < 990) {
		$(document).on('change paste keyup', '.boost-pfs-search-box', function () {
			if ($(this).val().length > 0) {
				$('body').addClass('search-active');
			} else {
				$('body').removeClass('search-active');
			}
		});
		// Remove class when click outside input
		$(document).click(function (e) {
			var container = $('.boost-pfs-search-suggestion-mobile-top-panel');
			if (!container.is(e.target) && container.has(e.target).length === 0) {
				$('body').removeClass('search-active');
			}
		});
	}

	$('.product__media-toggle').click(function () {
		$('.product-media-modal ').addClass('active');
		$(document).on('keydown', function (e) {
			if (e.key == 'Escape') {
				$('.product-media-modal ').removeClass('active');
				$(document).off('keydown', this);
			}
		});

		$('.slick-arrow').on('click', (e) => {
			e.stopPropagation();
		});

		$('.product-media-modal__toggle').click(function () {
			$('.product-media-modal ').removeClass('active');
		});

		$('.product-media-modal').click(function () {
			$('.product-media-modal ').removeClass('active');
		});
	});

	$('.product-media-modal__content.gradient').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		dots: false,
		autoplay: false,
		autoplaySpeed: 3000,
	});

	setTimeout(function () {
		$('.multicolumn-landing-wrapper .slick-prev.slick-arrow').addClass(
			'd-none'
		);
	}, 1000);

	jQuery(window).resize(function () {
		if (window.matchMedia('(max-width: 768px)').matches) {
			$('.multicolumn-landing-wrapper .slick-prev.slick-arrow').addClass(
				'd-none'
			);
		}
	});

	function alignHeightRow(selectorList, coutItem) {
		var interval = setInterval(function () {
			if ($(selectorList).length > 0) {
				var count = 0;
				var numberRow = 1;

				$(selectorList).each(function () {
					count++;
					$(this).addClass('row-' + numberRow);
					alignHeight('.row-' + numberRow);
					alignHeight('.row-' + numberRow + ' + .swym-is-button .swym-title');

					if (count == coutItem) {
						numberRow++;
						count = 0;
					}
				});
				clearInterval(interval);
			}
		}, 500);
	}

	if (jQuery(window).width() < 640) {
		alignHeightRow(
			'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper',
			2
		);

		jQuery(window).resize(function () {
			setTimeout(function () {
				alignHeightRow(
					'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper',
					2
				);
			}, 500);
		});
	}

	if (jQuery(window).width() >= 640 && jQuery(window).width() <= 949) {
		alignHeightRow(
			'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper',
			3
		);

		jQuery(window).resize(function () {
			setTimeout(function () {
				alignHeightRow(
					'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper',
					3
				);
			}, 500);
		});
	}

	if (jQuery(window).width() >= 950) {
		alignHeightRow(
			'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper',
			4
		);

		jQuery(window).resize(function () {
			setTimeout(function () {
				alignHeightRow(
					'.page-swym-wishlist .swym-ui-component .swym-wishlist-grid .swym-wishlist-image-wrapper',
					4
				);
			}, 500);
		});
	}

	$(document).click(function (e) {
		var alignSearch = $('#shopify-section-announcement-bar').height();
		var alignFormSearch = $(
			'.boost-pfs-search-suggestion-mobile-top-panel'
		).height();
		$('#boost-pfs-search-suggestion-mobile').attr(
			'style',
			'top:' + Number(alignSearch + alignFormSearch - 1) + 'px !important'
		);
		$('.boost-pfs-search-suggestion-mobile-top-panel').css('top', alignSearch);

		if ($('.boost-pfs-search-suggestion-mobile-top-panel').is(':visible')) {
			$('body').addClass('show-search');
			$('html').addClass('show-search');
		} else {
			$('body').removeClass('show-search');
			$('html').removeClass('show-search');
		}
	});

	$(document).on('blur', '.boost-pfs-search-box', function (e) {
		if ($('.boost-pfs-search-suggestion-mobile-top-panel').is(':hidden')) {
			$('body').removeClass('show-search');
			$('html').removeClass('show-search');
		}
	});

	$(document).on('focus', '.boost-pfs-search-box', function (e) {
		if ($('.boost-pfs-search-suggestion-mobile-top-panel').is(':hidden')) {
			$('body').removeClass('show-search');
			$('html').removeClass('show-search');
		}
	});

	setInterval(() => {
		if ($('.boost-pfs-search-suggestion-mobile-top-panel').is(':hidden')) {
			$('body').removeClass('show-search');
			$('html').removeClass('show-search');
		}

		if ($('.boost-pfs-search-suggestion-mobile-top-panel').is(':visible')) {
			var alignSearch = $('#shopify-section-announcement-bar').height();
			var alignFormSearch = $(
				'.boost-pfs-search-suggestion-mobile-top-panel'
			).outerHeight();
			$('#boost-pfs-search-suggestion-mobile').attr(
				'style',
				'top:' + Number(alignSearch + alignFormSearch - 1) + 'px !important'
			);
		}
	}, 1);

	jQuery(window).resize(function () {
		var alignSearch = $('#shopify-section-announcement-bar').height();
		var alignSearch = $(
			'.boost-pfs-search-suggestion-mobile-top-panel'
		).height();
		$('.boost-pfs-search-suggestion-mobile-top-panel').css('top', alignSearch);
	});

	// close modal body
	btnSize = $('#ProductPopup-guide')
	if (btnSize.length > 0) {
		btnSize.click(() => {
			$('body').removeClass('overflow-hidden')
		})
	}
});
